import React, { useEffect, useState } from "react";
import Tabs from "react-bootstrap/Tabs";
import { BasicTab } from "./features/BasicTab";
import { Tab } from "react-bootstrap";
import { ShippingInformationTab } from "./features/ShippingInformationTab";
import { ContactTab } from "./features/ContactTab";
import { AddressTab } from "./features/AddressTab";
import { PTATab } from "./features/PTATab";
import { BeforeApprovalTab } from "./features/BeforeApprovalTab";
import { useLocation, useParams } from "react-router-dom";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import {
    useCreateAccountBusinessFile,
    useReadAccountBasicInfo,
    useReadAccountShipmentInfo,
    useSaveAccountShipmentInfo,
    useUpdateAccountInfo,
} from "./hooks";
import { SubmitHandler, useForm, useWatch } from "react-hook-form";
import { defaultBasicClientInfo, defaultShipmentInfo } from "./state";
import { useEditMode, useModal } from "../../../../hooks";
import { BasicClientInfoType, SearchAccountType, SearchAddressResType } from "./interface";
import useDeleteAccountBusinessFile from "./hooks/useDeleteAccountBusinessFile";
import AuthorityChecker from "../../../../components/common/authorityGuard/AuthorityChecker";

type Props = {
    isCreate?: boolean;
};

export const CorrespondentDetail = ({ isCreate = false }: Props) => {
    const [key, setKey] = useState<string | null>("기본정보");
    const [file, setFile] = useState<(File & { fileId?: number }) | null>(null);
    const params = useParams();
    const location = useLocation();
    const { goToNavigation } = useGoToNavigation();
    const { mode, setRead, setUpdate } = useEditMode();
    const { handleModal } = useModal();

    const [checkedAddress, setCheckedAddress] = useState<SearchAddressResType[]>([])

    // 거래처 정보
    //const searchData = location?.state;
    // 내부수정: 새창(state 없음)일 때 sessionStorage에서 복구
    const searchData = location?.state ?? (() => {
        try {
            const key = `nav_state:customer/correspondent/detail/${params?.id}`;
            const raw = sessionStorage.getItem(key);
            if (raw) {
                return JSON.parse(raw);
            }
        } catch {}
        return undefined;
    })();
    
    const { data: basicInfoData } = useReadAccountBasicInfo(params?.id ?? "");
    const { data: shipmentInfoData } = useReadAccountShipmentInfo({
        searchData: {
            ...searchData,
        },
    });

    useEffect(() => {
        console.log("location", location.state);
        console.log("basicInfoData", basicInfoData);
    }, [location, basicInfoData
    ])

    const { mutate: mutateUpdateAccountInfo } = useUpdateAccountInfo({ setRead, isCreate, isFileManaged: !!file?.fileId });
    const { mutate: mutateSaveAccountShipmentInfo } = useSaveAccountShipmentInfo({
        setRead,
    });
    const { mutate: uploadFileMutate } = useCreateAccountBusinessFile({
        setRead,
    });
    const { mutate: deleteFileMutate } = useDeleteAccountBusinessFile({
        setRead,
    });

    /**
     * basic info form
     */
    const {
        register,
        handleSubmit,
        reset,
        control,
        formState: { isDirty },
        setValue,
    } = useForm({
        defaultValues: defaultBasicClientInfo,
    });

    /**
     * shipment form
     */
    const {
        register: shipmentRegister,
        handleSubmit: shipmentHandleSubmit,
        reset: shipmentRest,
        control: shipmentControl,
        formState: shipmmentFormState,
        setValue: shipmentSetValue,
    } = useForm({
        defaultValues: (() => defaultShipmentInfo)(),
    });

    const watchesBasicInfo = {
        ...defaultBasicClientInfo,
        ...useWatch<BasicClientInfoType>({ control }),
    };

    const watchSnipmentInfo = {
        ...defaultShipmentInfo,
        ...useWatch<SearchAccountType>({ control: shipmentControl }),
    };

    useEffect(() => {
        if (!params?.id && !isCreate) {
            goToNavigation(-1, {}, true);
        }
        if (isCreate) {
            reset(defaultBasicClientInfo);
        }
    }, []);

    const btnUpdate = () => {
        if (key === "기본정보") {
            if (basicInfoData) {
                setUpdate();
                reset(basicInfoData);
            }
        } else if (key === "출하정보") {
            setUpdate();
            shipmentInfoData && shipmentRest(shipmentInfoData);
        }
    };

    const btnCancel = () => {
        if (key === "기본정보") {
            if (isCreate) {
                goToNavigation(-1, {}, true);
            } else {
                setRead();
                reset(defaultBasicClientInfo);
            }
        } else if (key === "출하정보") {
            setRead();
        }
    };

    const onSubmitUpdateAccountInfo: SubmitHandler<BasicClientInfoType> = (
        submitData
    ) => {
        console.log("file", file);
        console.log("submitData", submitData);

        // if (isDirty) {
        mutateUpdateAccountInfo(submitData, {
            onSuccess: () => {
                if (file?.fileId) {
                    return;
                }
                if (file) {
                    const form = new FormData();
                    form.append("accountId", basicInfoData?.accountId as string);
                    form.append("file", file);
                    uploadFileMutate(form);
                } else {
                    console.log("파일 없을때", searchData);
                    deleteFileMutate({
                        accountId: searchData?.accountId,
                        chargeName: searchData?.chargeName,
                        customerCategoryName: searchData?.customerCategory,
                        defaultContact: searchData?.defaultContact,
                        erpAccountName: searchData?.erpAccountName,
                        industryName: searchData?.industryName,
                        name: searchData?.name,
                    });
                }
            }
        });
        // }

    };

    const onSubmitShipment: SubmitHandler<SearchAccountType> = (submitData) => {
        mutateSaveAccountShipmentInfo({
            ...submitData,
            accountId: params?.id ?? "",
        });
    };

    const UpperBtn = () => {
        return mode !== "R" || isCreate ? (
            <React.Fragment>
                {key === "기본정보" ? (
                    <button
                        className="btn btn-primary w-100px h-38px"
                        onClick={handleSubmit(onSubmitUpdateAccountInfo)}
                    >
                        저장
                    </button>
                ) : (
                    <button
                        className="btn btn-primary w-100px h-38px"
                        onClick={shipmentHandleSubmit(onSubmitShipment)}
                    >
                        저장
                    </button>
                )}
                <button
                    className="btn btn-outline-secondary w-100px h-38px"
                    onClick={() => {
                        btnCancel();
                    }}
                >
                    취소
                </button>
            </React.Fragment>
        ) : (
            <>
                <button
                    className="btn btn-outline-primary w-100px h-38px"
                    onClick={() => {
                        goToNavigation('customer/correspondent/list', {}, true);
                    }}
                >
                    <img
                        src={
                            process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"
                        }
                        alt=""
                    />
                    목록
                </button>
                <AuthorityChecker authorityNames={['clientWriteYn']}>
                    <button
                        className="btn btn-secondary w-100px h-38px"
                        onClick={() => btnUpdate()}
                    >
                        수정
                    </button>
                </AuthorityChecker>
            </>
        );
    };

    return (
        <>
            <div className="content_wrap mb-15px">
                <div className="fiter_top">
                    <h3 className="filter_heading">
                        {isCreate ? "거래처 생성" : "거래처 상세보기"}
                    </h3>
                    <div className="filter_toolbar">
                        {key === "기본정보" && <UpperBtn />}

                        {key === "출하정보" && <UpperBtn />}

                        {key === "이전 결제 건" && (
                            <React.Fragment>
                                <button
                                    className="btn btn-outline-primary w-100px h-38px ms-40px"
                                    onClick={() => {
                                        goToNavigation('customer/correspondent/list', {}, true);
                                    }}
                                >
                                    <img
                                        src={
                                            process.env.PUBLIC_URL +
                                            "/assets/images/icon_hamburger_btn.png"
                                        }
                                        alt=""
                                    />
                                    목록
                                </button>
                            </React.Fragment>
                        )}

                        {key === "PTA 레벨" && (
                            <React.Fragment>
                                <button
                                    className="btn btn-outline-primary w-100px h-38px ms-40px"
                                    onClick={() => {
                                        goToNavigation('customer/correspondent/list', {}, true);
                                    }}
                                >
                                    <img
                                        src={
                                            process.env.PUBLIC_URL +
                                            "/assets/images/icon_hamburger_btn.png"
                                        }
                                        alt=""
                                    />
                                    목록
                                </button>
                            </React.Fragment>
                        )}

                        {key === "연락처" && (
                            <React.Fragment>
                                <button
                                    className="btn btn-outline-primary w-100px h-38px ms-40px"
                                    onClick={() => {
                                        goToNavigation('customer/correspondent/list', {}, true);
                                    }}
                                >
                                    <img
                                        src={
                                            process.env.PUBLIC_URL +
                                            "/assets/images/icon_hamburger_btn.png"
                                        }
                                        alt=""
                                    />
                                    목록
                                </button>
                            </React.Fragment>
                        )}

                        {key === "주소" && (
                            <React.Fragment>
                                <button
                                    className="btn btn-outline-primary w-100px h-38px ms-40px"
                                    onClick={() => {
                                        goToNavigation('customer/correspondent/list', {}, true);
                                    }}
                                >
                                    <img
                                        src={
                                            process.env.PUBLIC_URL +
                                            "/assets/images/icon_hamburger_btn.png"
                                        }
                                        alt=""
                                    />
                                    목록
                                </button>
                            </React.Fragment>
                        )}
                    </div>
                </div>

                <h5 className="subheading">거래처 정보</h5>
                <div className="table_scroll mb-0">
                    <table className="table table-bordered my_table table_detail">
                        <tbody>
                            <tr>
                                <th style={{ width: "16.66%" }}>거래처명</th>
                                <td colSpan={3}>
                                    {isCreate ? watchesBasicInfo?.name : basicInfoData?.name}
                                </td>
                            </tr>
                            <tr>
                                <th style={{ width: "16.66%" }}>생성일자</th>
                                <td style={{ width: "33.34%" }}>{basicInfoData?.createdon}</td>
                                <th style={{ width: "16.66%" }}>생성자</th>
                                <td>{basicInfoData?.createName}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="position-relative">
                {isCreate ? (
                    <BasicTab
                        basicInfoData={basicInfoData}
                        register={register}
                        mode={isCreate ? "C" : mode}
                        watchesBasicInfo={watchesBasicInfo}
                        setFile={setFile}
                        setValue={setValue}
                    />
                ) : (
                    <>
                        <Tabs
                            defaultActiveKey="기본정보"
                            activeKey={key as string}
                            transition={false}
                            className="mytab_pills mb-15px"
                            variant="pills"
                            onSelect={(k) => {
                                mode === "C" || mode === "U"
                                    ? handleModal({
                                        isOpen: true,
                                        contents: "편집 중에는 탭을 변경할 수 없습니다.",
                                        type: "alert",
                                    })
                                    : setKey(k);
                            }}
                        >
                            <Tab eventKey="기본정보" title="기본정보">
                                <BasicTab
                                    basicInfoData={basicInfoData}
                                    register={register}
                                    mode={mode}
                                    setFile={setFile}
                                    setValue={setValue}
                                    watchesBasicInfo={watchesBasicInfo}
                                />
                            </Tab>

                            <Tab eventKey="출하정보" title="출하정보">
                                <ShippingInformationTab
                                    data={shipmentInfoData}
                                    mode={mode}
                                    register={shipmentRegister}
                                    setValue={shipmentSetValue}
                                    watchShipmentInfo={watchSnipmentInfo}
                                />
                            </Tab>
                            <Tab eventKey="이전 결제 건" title="이전 결제 건">
                                <BeforeApprovalTab />
                            </Tab>
                            <Tab eventKey="PTA 레벨" title="PTA 레벨">
                                <PTATab searchData={searchData} name={basicInfoData?.newTxtNmPartner ?? null} />
                            </Tab>
                            <Tab eventKey="연락처" title="연락처">
                                <ContactTab id={params?.id as string} />
                            </Tab>
                            {/* 내부수정: 관련 거래처명 전달 */}
                            <Tab eventKey="주소" title="주소">
                                <AddressTab id={params?.id as string}
                                    accountName={basicInfoData?.name} 
                                    checkedAddress={checkedAddress}
                                    setCheckedAddress={setCheckedAddress} />
                            </Tab>
                        </Tabs>
                    </>
                )}
            </div>
        </>
    );
};
